<template>
  <div class="pub-page">
    <div class="pub-header d-flex align-items-center">
      <text class="title me-1">{{$route.meta.title}}</text>
    </div>
    <div class="pub-center">
      <el-table scrollbar-always-on border   :data="list" style="width: calc(100% - 30px);position: absolute;left: 15px;top:10px;padding-bottom: 30px"  v-loading="loading">
        <el-table-column label="序号"   width="80px">
          <template #default="scope">
            {{(params.pageSize * (params.current-1)) + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column label="文件名称" >
          <template #default="scope">
            {{scope.row.Name || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="年份" width="100px">
          <template #default="scope">
            {{scope.row.Year || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="170px">
          <template #default="scope">
            {{scope.row.CreatedTime || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120px" >
          <template #default="scope">
            <a class="el-button el-button--primary el-button--small text-decoration-none" @click="handleDownload(scope.$index, scope.row)">下载</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pub-footer d-flex align-items-center justify-content-center">
      <el-pagination  v-show="total>0" background
                      layout="total, sizes, prev, pager, next"
                      :page-sizes="[10, 20, 30, 40]"
                      :total="total"
                      v-model:current-page="params.current"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {ElMessage,ElMessageBox} from "element-plus";
import {getDocs} from "@/api/student";
import {formatTime} from "@/utils/dateFun";
import {downLoad} from "@/utils/downloadFiles";
import {useStore} from "vuex";
import { useRouter } from "vue-router";
let router = useRouter();
const store = useStore()
const params = reactive({
  pageSize:10,
  current:1,
  name:null
})
const total = ref(0)
const list = ref([])
const loading = ref(false)
onMounted(()=>{
  getList()
  getUserInfo()
})
// 获取用户信息
const incompleteInfo = ref(true)
const getUserInfo = async ()=>{
  await store.dispatch("loginModel/getUserInfo") //获取用户信息
  incompleteInfo.value = store.getters["loginModel/getStudentInfoIncomplete"]
  if(incompleteInfo.value){
    return  ElMessageBox.alert('请补充参赛队信息后再上传作品，去补充？', '补充信息', {
      confirmButtonText: '确定',
      callback: (action) => {
        if(action==='confirm'){ // 确定
          router.push({path:'/student/teams'})
        }
      },
    })
  }
}
// 列表
const getList = async (init)=>{
  if(init){
    params.current = 1
  }
  loading.value = true
  const res = await getDocs(params)
  loading.value = false
  if(res.success){
    total.value = res.total
    let data = res.data || []
    data.forEach(item=>{
      //  创建时间
      if(item.CreatedAt){
        item.CreatedTime = formatTime(item.CreatedAt)
      }
    })
    list.value = data
  }else{
    return  ElMessage.warning("获取列表失败")
  }
}
const handleSizeChange = (event) => {
  if(params.pageSize !==event){
    params.current = 1
    params.pageSize = event
    getList()
  }
}
const handleCurrentChange = ()=>{
  getList()
}
// 下载
const handleDownload =(index,item)=>{
  downLoad(item.Link,item.Name)
}
</script>

<style scoped lang="scss">


</style>
